/**
 * @fileoverview Sistema de logging centralizado para Nubelytics
 * Implementa patrón Singleton y abstracción sobre console.log
 */

/**
 * Logger centralizado con niveles de severidad y prefijos contextuales
 * Facilita el debugging y monitoreo de la aplicación
 */
class Logger {
  constructor() {
    this.prefix = '[Nubelytics]';
    this.enabled = process.env.NODE_ENV !== 'test';
    this.debugEnabled = process.env.REACT_APP_DEBUG === 'true' || localStorage.getItem('debug') === 'true';
  }

  /**
   * Registra un mensaje informativo
   * @param {string} message - Mensaje principal
   * @param {*} data - Datos adicionales (opcional)
   */
  info(message, data) {
    if (!this.enabled) return;
    if (data) {
      console.info(`${this.prefix} INFO: ${message}`, data);
    } else {
      console.info(`${this.prefix} INFO: ${message}`);
    }
  }

  /**
   * Registra un mensaje de advertencia
   * @param {string} message - Mensaje principal
   * @param {*} data - Datos adicionales (opcional)
   */
  warn(message, data) {
    if (!this.enabled) return;
    if (data) {
      console.warn(`${this.prefix} WARN: ${message}`, data);
    } else {
      console.warn(`${this.prefix} WARN: ${message}`);
    }
  }

  /**
   * Registra un mensaje de error
   * @param {string} message - Mensaje principal
   * @param {*} error - Objeto de error o datos adicionales
   */
  error(message, error) {
    if (!this.enabled) return;
    if (error) {
      console.error(`${this.prefix} ERROR: ${message}`, error);
    } else {
      console.error(`${this.prefix} ERROR: ${message}`);
    }
  }

  /**
   * Registra un mensaje de depuración (solo visible si debug está activado)
   * @param {string} message - Mensaje principal
   * @param {*} data - Datos adicionales (opcional)
   */
  debug(message, data) {
    if (!this.enabled || !this.debugEnabled) return;
    if (data) {
      console.debug(`${this.prefix} DEBUG: ${message}`, data);
    } else {
      console.debug(`${this.prefix} DEBUG: ${message}`);
    }
  }
}

// Exportar instancia singleton
const logger = new Logger();
export default logger;
